import { notify } from '@/utils/notify';
import AlertIcon from '@/components/Notifications/AlertIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import { openProfileModal } from '@/utils/profileModal';

/**
 * Guard for actions that require a Steam trade link. Shows the
 * "Need put tradelink!" notice and opens the profile modal with the
 * trade-link field highlighted, instead of routing to the profile page.
 */
export function requireTradeLink() {
    notify(
        'error',
        <AlertIcon />,
        <NotifyWrapper title="Error" text="Need put tradelink!" />
    );
    openProfileModal('account', { highlightTradeLink: true });
}
